import { useEffect, useState } from "react"
import { LanguageContextProps, MessagesDICT } from "../types"
import { AppLocale, DEFAULT_LOCALE } from "@/config/locales"
import _ from "lodash"
import { createMessages, getMessages, loadLocaleData } from "../helpers/messages"

export type LanguageProviderProps = {
    contextValue: LanguageContextProps
    messages?: Record<string, string>
}

export const useLanguageProvider = (defaultLocale?: AppLocale): LanguageProviderProps => {
    const [locale, setLocale] = useState<AppLocale>(defaultLocale ?? DEFAULT_LOCALE)
    const handleAppLocale = (language: AppLocale) => {
        setLocale(language)
    }

    const [messages, setMessages] = useState<MessagesDICT | undefined>(undefined)
    // preload default Intl messages
    useEffect(() => {
        loadLocaleData(locale).then((d) => {
            setMessages(createMessages(d.default, undefined))
        })
    }, [locale])

    return {
        contextValue: {
            locale,
            handleAppLocale,
        },
        messages: messages ? getMessages(messages) : undefined,
    }
}
